import React from 'react';
import { Link } from 'react-router-dom';
import './banner.css';
import SlideUpOnScroll from './slide-up';
import {LinkButton} from "./link-button";
import bannerImage from '../assets/banner.svg';
import bannerMobile from '../assets/banner-mobile.png';

class BannerSection extends React.Component {

    render() {
        const isMobile = window.innerWidth <= 650;

        return <Link to={'/get-in-touch'}>
            <div id='message-section' className='black-back p-vert-04p'>
                { !isMobile && <img className='banner-image' alt='black and blue background' src={bannerImage} />}
                { isMobile && <img className='banner-image' alt='black and blue background' src={bannerMobile} />}

                <h1 className='text-center mb-4 white-color-txt t3'>
                    <SlideUpOnScroll> Custom software that works. <br/>Start your project with us today. </SlideUpOnScroll>
                </h1>

                <SlideUpOnScroll>
                    <LinkButton to="/get-in-touch" text="Get in touch" className="white-border background-transparent light-button-hover" />
                </SlideUpOnScroll>
            </div>
        </Link>
    }
}

export default BannerSection;